import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { SurveyRoutingModule } from './survey-routing.module';
import { SurveyComponent } from './survey.component';
import { SurveyService } from './survey.service';

@NgModule({
  imports: [CommonModule, CoreModule, SurveyRoutingModule],
  declarations: [SurveyComponent],
  providers: [SurveyService]
})
export class SurveyModule {}
